var Acr = Acr || {};

Acr.AccordionNavigation = function () {
  var $navigation;
  var $navigationList;
  var $navigationItemClone;
  var isJustCta = false;
  const activeSelectorClass = '.active';
  const cloneClass = 'acr-accordion-navigation__clone';
  const expandedClass = 'expanded';
  const justCtaClass = 'just-cta';
  const navigationListSelectorClass = '.js-acr-accordion-navigation__items';
  const navigationItemSelectorClass = '.js-acr-accordion-navigation__item';

  function toggleAccordion(e) {
    e.preventDefault();
    var toogleNav = $navigation.classList.contains(expandedClass);
    if (toogleNav) {
      $navigationList.style.removeProperty('height');
      $navigation.classList.remove(expandedClass);
    } else {
      $navigation.classList.add(expandedClass);
      var navigationListSize = $navigationList.scrollHeight;
      var viewHeight = document.documentElement.clientHeight;
      var parentPositionSize = $navigationList.parentElement.offsetTop + $navigationList.parentElement.offsetHeight;
      var calcViewSize = viewHeight - parentPositionSize;
      var finalHeightSize = calcViewSize > navigationListSize ? calcViewSize : navigationListSize;
      $navigationList.style.height = finalHeightSize + 'px';
    }
  }

  function initSelectors(element) {
    $navigation = element;
    var navigationItemActive = $navigation.querySelector(navigationItemSelectorClass + activeSelectorClass);
    var navigationItemActiveLink = navigationItemActive.querySelector('.acr-accordion-navigation__item__link');
    var cloneActiveLink = navigationItemActiveLink.cloneNode(true);

    $navigationItemClone = document.createElement('span');
    $navigationItemClone.appendChild(cloneActiveLink);
    $navigationItemClone.classList.add(cloneClass);

    $navigationList = $navigation.querySelector(navigationListSelectorClass);
    $navigation.insertBefore($navigationItemClone, $navigationList);

    isJustCta = $navigation.classList.contains(justCtaClass);
  }

  function bindEvents() {
    if (!isJustCta) {
      $navigationItemClone.addEventListener('click', toggleAccordion);
    }
  }

  function init(element) {
    console.log('this is acr navigation');
    initSelectors(element);
    bindEvents();
  }

  return {
    init: init,
  };
};
